/**
 * IssuePageRedirect - Redirects from /issues/:issueId/pages/:pageNumber to /pages/:pageId
 * This supports the CSV export URL format
 */
import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { Box, CircularProgress, Typography, Alert, Container } from '@mui/material';
import { pagesAPI } from '../services/api';

const IssuePageRedirect = () => {
  const { issueId, pageNumber } = useParams();
  const navigate = useNavigate();

  // Fetch page by issue ID and page number
  const { data, isLoading, error } = useQuery(
    ['pageByIssueAndNumber', issueId, pageNumber],
    () => pagesAPI.getByIssueAndNumber(issueId, pageNumber),
    { enabled: !!issueId && !!pageNumber }
  );

  useEffect(() => {
    if (data?.data?.results?.length > 0) {
      // Redirect to the page detail page using the page ID
      const pageId = data.data.results[0].id;
      navigate(`/pages/${pageId}`, { replace: true });
    }
  }, [data, navigate]);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || (data && data.data?.results?.length === 0)) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Alert severity="error">
          Page not found. Issue {issueId}, Page {pageNumber} does not exist.
        </Alert>
      </Container>
    );
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <CircularProgress />
    </Box>
  );
};

export default IssuePageRedirect;
